import { api } from './api-client';
import { toQueryString } from './query';
import { ApiResponse, PaginatedResponse, PaginationQuery, Warehouse } from '../types/api';

export type WarehouseInput = Omit<Warehouse, 'id' | 'active'>;
export interface WarehouseQuery extends PaginationQuery { active?: boolean; }

export async function listWarehouses(query: WarehouseQuery = {}) {
  const response = await api.get<PaginatedResponse<Warehouse>>(`/warehouses${toQueryString(query)}`);
  return response.data;
}
export async function createWarehouse(input: WarehouseInput) {
  const response = await api.post<ApiResponse<Warehouse>>('/warehouses', input);
  return response.data.data;
}
export async function getWarehouse(id: number) {
  const response = await api.get<ApiResponse<Warehouse>>(`/warehouses/${id}`);
  return response.data.data;
}
export async function updateWarehouse(id: number, input: Partial<WarehouseInput>) {
  const response = await api.patch<ApiResponse<Warehouse>>(`/warehouses/${id}`, input);
  return response.data.data;
}
export async function updateWarehouseStatus(id: number, active: boolean) {
  const response = await api.patch<ApiResponse<Warehouse>>(`/warehouses/${id}/status`, { active });
  return response.data.data;
}
